import { ReportRequest } from '../../report/models/report-request.model';

export class NewReportEvent {
    description: string;
    reportType: string;
    label: string;
    category: string;
    hasVehicleLevelAdjustments: boolean;
    hasUsedValuation: boolean;
    hasFutureValuation: boolean;
    futureValuationType: string;
    hasContractTermAdjustments: boolean;
    hasMileageAdjustments: boolean;
    datasetUsed: string;
    vehicleCondition: string;

    constructor() {
        this.hasUsedValuation = false;
        this.hasFutureValuation = false;
        this.hasContractTermAdjustments = false;
        this.hasMileageAdjustments = false;
        this.description = 'User clicked Build Report';
        this.category = 'New Report';
    }

    updateValuationFlagsForReport() {
        const reportTypeNameUpper = this.reportType.toUpperCase();
        this.label = this.reportType;
        if (reportTypeNameUpper.startsWith('FUTURE')
            || reportTypeNameUpper.startsWith('MILEAGE')) {
                this.hasFutureValuation = true;
        }

        if (reportTypeNameUpper.startsWith('USED')
            || reportTypeNameUpper.startsWith('UNSOLD')
            || reportTypeNameUpper.startsWith('DISPOSAL')) {
            this.hasUsedValuation = true;
            }
    }
}


// WEBPACK FOOTER //
// ./src/app/events/models/new-report-event.model.ts